








































































































































































































































































































import { Component, Emit, Mixins, Prop } from "vue-property-decorator";
import { Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { MediaQuery as MQ } from '@/MediaQuery';
import { BankModule, NavModule, PaymentMethod, ProfileModule } from "@/store";
import PaymentMethodAuthorizeNet from "@/views/account/paymentmethods/authorizenet/AuthorizeNetPayment.vue";
// import PaymentAddSquare from "@/views/account/paymentmethods/square/SquareAddCard.vue";
import PaymentMethodSquare from "@/views/account/paymentmethods/square/SquarePayment.vue";
import { mdbBtn, mdbInput } from "mdbvue";
// import { VCol, VContainer, VRow } from 'vuetify/lib';
// import { RouterIcons } from "@/router/RouterIcons";
import { RouterUtils } from "@/router/RouterUtils";
import { EditableUser } from "@/views/account";
import { WebappLogger } from "@/WebappLogger";

@Component({
  components: {
    // PaymentAddSquare,
    PaymentMethodSquare,
    PaymentMethodAuthorizeNet,
    mdbBtn,
    mdbInput,
    // VCol,
    // VContainer,
    // VRow
  }
})
export default class MakeDeposit extends Mixins(RouterUtils) {
  bankStore: BankModule = getModule(BankModule, this.$store);
  navStore: NavModule = getModule(NavModule, this.$store);
  profileStore: ProfileModule = getModule(ProfileModule, this.$store);
  MQ = MQ;

  errorMessage: string | null = null;
  successMessage: string | null = null;

  @Prop({ default: false })
  showSkipBtn!: boolean;

  errorRestart: boolean = false;

  activeSection: string = "#deposits-form";
  participants: any[] = [];
  endOfSession: any = null;
  totalDeposit: string = "0.00";
  fromAccount: any | null = null;
  toAccount: any | null = null;
  refundThreshold: number = 0;
  hasCard: boolean = false;
  cardString: string | null = null;
  isProcessing: boolean = false;
  donateSelection: string = "";
  refundDonateOptions: any[] = [];
  processorAuthorizeNetDataDescriptor: string | null = null;
  processorAuthorizeNetDataValue: string | null = null;
  processorSquareDefaultCard: any = null;
  processorSquareNonce: string | null = null;
  webProcessor: string | null = null;
  
  get allocations() {
    let allocations = this.participants
      .filter(person => person.deposit)
      .map(person => {
        let allocation = {
          amount: parseFloat(person.deposit),
          authUserId: person.userId
        };
        return allocation;
      });
    return allocations;
  }
  get authUsers() {
    return this.profileStore.authorizedActiveUsers;
  }
  get contributingTo() {
    return this.bankStore.contributingToActive;
  }
  get displayDonateOptions(): boolean {
    return this.navStore.displayDonateOptions;
  }
  get displayEndSessionMessage(): boolean {
    return this.navStore.displayEndSessionMessage;
  }
  get donateSelectionVal(): string | null {
    // get end-of-session handling
    let donateSelectionVal = null;
    if (
      this.endOfSession &&
      this.endOfSession.refundDonate &&
      this.endOfSession.donateSelection
    ) {
      donateSelectionVal = this.endOfSession.donateSelection;
    }
    return donateSelectionVal;
  }
  get endSessionMessage(): string | null {
    return this.navStore.endSessionMessage;
  }
  get endOfSessionVal(): string | null {
    // get end-of-session handling
    let endOfSessionVal: string | null = null;
    if (
      this.endOfSession &&
      this.endOfSession.refundDonate
    ) {
      endOfSessionVal = this.endOfSession.refundDonate;
    }
    return endOfSessionVal;
  }
  get isValidSquarePaymentCardEntered(): boolean {
    if (this.displayDonateOptions === true && this.endOfSessionVal == null) return false;
    return true;
  }
  get isValidSquarePaymentCardOnFile(): boolean {
    if (
      !this.hasCard ||
      (this.navStore.displayDonateOptions &&
        (this.endOfSession == null || this.endOfSession === "")) ||
      this.isProcessing
    ) {
      return true;
    } else {
      return false;
    }
  }
  get isDepositButtonDisabled(): boolean {
    if (parseFloat(this.totalDeposit) <= 0) {
      return true;
    }
    return false;
  }
  // methodOptions () {
  //   let options = []
  //   for (let index in this.getPaymentMethods()) {
  //     let method = this.getPaymentMethods()[index]
  //     // let option = { text: this.$tc('phrase.select_account'), value: null, disabled: true, selected: true }
  //     options.push(options)
  //   }
  //   return options
  // },
  get paymentMethods() {
    return this.profileStore.paymentMethods;
  }
  get showAddUser() {
    return this.navStore.allowCreateAuthorizedUsers && this.$route.query.rtn === undefined;
  }
  get totalDepositAsFloat(): number {
    return parseFloat(this.totalDeposit || "0");
  }

  // detect if the $route.hash has changed
  @Watch("contributingTo")
  onContributingToChange(/* contributingTo, old */) {
    this.setup();
  }
  @Watch("authUsers")
  onAuthUsersChange(/* authUsers, old */) {
    this.setup();
  }
  @Watch("$route", { immediate: true, deep: true })
  onRouteHashChange(newRoute: any, oldRoute: any) {
    if (oldRoute === undefined || oldRoute.hash !== newRoute.hash) {
      // console.log('location change', oldVal, newVal, this.$route.hash)
      if (this.$route.hash === "" || this.$route.hash === "#deposits-form") {
        this.setup();
      } else {
        this.activeSection = this.$route.hash;
      }
    }
  }

  calcTotalDeposit() {
    var total = 0.0;
    for (var index in this.participants) {
      let person = this.participants[index];
      if (
        person.deposit != null &&
        person.deposit !== "" &&
        !isNaN(person.deposit)
      ) {
        person.deposit = parseFloat(person.deposit).toFixed(2);
        total = total + parseFloat(person.deposit);
      }
    }
    this.totalDeposit = total.toFixed(2);
  }
  goFormStep() {
    this.setup();
    window.location.hash = "deposits-form";
    this.activeSection = "#deposits-form";
    this.totalDeposit = "0.00";
    this.errorMessage = null;
    this.errorRestart = false;
  }
  goPostAuthorizeNetPayment(e: any) {
    // console.log('goPostAuthorizeNetPayment ', e);
    // console.log('goPostAuthorizeNetPayment ', e.dataDescriptor);
    // console.log('goPostAuthorizeNetPayment ', e.dataValue);
    if (e !== undefined && e.dataDescriptor !== undefined) this.processorAuthorizeNetDataDescriptor = e.dataDescriptor;
    if (e !== undefined && e.dataValue !== undefined) this.processorAuthorizeNetDataValue = e.dataValue;
    this.handleNextClick();
  }
  goPostSquareAddCard(e: any) {
    // console.log('goPostSquareAddCard ', e);
    // console.log('goPostSquareAddCard .nonce=', e.nonce);
    if (e !== undefined && e.nonce !== undefined) this.processorSquareNonce = e.nonce;
    this.handleNextClick();
  }
  goPostSquarePayment(e: any) {
    // console.log('goPostSquarePayment ', e);
    // console.log('goPostSquarePayment e.nonce=', e.nonce);
    if (e !== undefined && e.nonce !== undefined) this.processorSquareNonce = e.nonce;
    // console.log('goPostSquarePayment processorSquareNonce=', this.processorSquareNonce);
    this.handleNextClick();
  }
  async handleDepositResponse(res: any) {
    this.successMessage = null;
    // console.log("make deposit response ", res);
    this.isProcessing = false;
    if (
      res &&
      res.data !== undefined &&
      (res.data.status === "200" ||
        res.data.code === "200" ||
        res.data.code === "COMPLETE")
    ) {
      this.errorMessage = null;
      this.successMessage = "The funds have been deposited!";
      this.activeSection = "#deposits-result";
      this.navStore.resetBackbarStack();
      // refresh the data
      await this.profileStore.fetchAllDetails();
      // this.profileStore.fetchAuthorizedPersons({
      //   authorizedUsers: this.profileStore.authorizedActiveUsers,
      //   contributingTo: this.bankStore.contributingToActive
      // });
      // refresh transactions
      this.bankStore.fetchUserTransactions({ userId: this.profileStore.userId });
    } else if (res.data.code === "SQUARE_INVALID_EXPIRATION") {
      this.errorMessage = res.data.message;
      this.errorRestart = true;
    } else {
      // console.log(
      //   "Error on Response ",
      //   res.data.code,
      //   res.data.message,
      //   res.status,
      //   res.data
      // );
      this.errorMessage = res.data.message;
      this.errorRestart = true;
      // console.log("err msg ", this.errorMessage);
    }
    if (this.errorRestart) {
      await this.profileStore.fetchAllDetails().catch();
    }
  }
  @Emit('next')
  handleDoneClick() {
    return;
  }
  handleNextClick() {
    // add route to stack
    this.navStore.pushBackbarStack(this.$route);
    // add hash to URL
    if (this.activeSection === "#deposits-form") {
      if (this.processorSquareDefaultCard != null) {
        // this.processorSquareNonce = this.processorSquareDefaultCard.squareCardId;
        window.location.hash = "deposits-confirm";
        this.activeSection = "#deposits-confirm";
      } else {
        window.location.hash = "deposits-payment";
        this.activeSection = "#deposits-payment";
      }
    } else if (this.activeSection === "#deposits-confirm") {
      window.location.hash = "charge-card";
      this.activeSection = "#charge-card";
    } else {
      window.location.hash = "deposits-confirm";
      this.activeSection = "#deposits-confirm";
    }
  }
  @Emit('skip')
  handleSkipClick() {
    return;
  }
  // handleVerifyClick() {
  //   // process deposit
  //   this.isProcessing = true;

  //   if (this.webProcessor === 'authorize-net') {
  //     this.handleVerifyClickByAuthorizeNet();
  //   }
  //   if (this.webProcessor === 'square') {
  //     this.handleVerifyClickBySquare();
  //   }
  // },
  handleVerifyClickByAuthorizeNet(/* responseData: any */) {
    // console.log('handleVerifyClickByAuthorizeNet responseData', responseData);
    // console.log('handleVerifyClickByAuthorizeNet this.processorAuthorizeNetDataDescriptor', this.processorAuthorizeNetDataDescriptor);
    // console.log('handleVerifyClickByAuthorizeNet this.processorAuthorizeNetDataValue', this.processorAuthorizeNetDataValue);
    // process deposit
    this.isProcessing = true;
    const payload = {
      depositAmount: parseFloat(this.totalDeposit),
      endOfSession: this.endOfSessionVal || undefined,
      donateSelection: this.donateSelectionVal || undefined,
      allocations: this.allocations,
      opaqueDataDescriptor: this.processorAuthorizeNetDataDescriptor,
      opaqueDataValue: this.processorAuthorizeNetDataValue
    };
    this.bankStore.depositFundsAuthorizeNet(payload)
      .then(async res => {
        await this.handleDepositResponse(res);
      })
      .catch(err => {
        // console.log("Deposit funds authorize-net error", err);
        let errorMsg =
          "There was a problem encountered while making the deposit";
        if (
          err &&
          err.message &&
          err !== undefined &&
          err.message !== undefined
        ) {
          errorMsg = `${errorMsg}: ${err.message}`;
        }
        this.successMessage = null;
        this.errorMessage = errorMsg;
        this.isProcessing = false;
        WebappLogger.warn(errorMsg, 'MakeDeposit.handleVerifyClickByAuthorizeNet.catch', err.name, undefined, this.profileStore.organizationId, this.profileStore.userId).catch();
      });
    // complete payment
  }
  handleVerifyClickBySquare() {
    // 
    // let cardId: string | undefined;
    // if (this.hasCard && this.processorSquareDefaultCard != null && this.processorSquareNonce == null) {
    //   this.processorSquareNonce = 'CARDID';
    // }
    // process deposit
    this.isProcessing = true;
    const payload = {
      depositAmount: parseFloat(this.totalDeposit),
      endOfSession: this.endOfSessionVal || undefined,
      donateSelection: this.donateSelectionVal || undefined,
      allocations: this.allocations,
      cardNonce: this.processorSquareNonce
    };
    this.bankStore.depositFundsSquare(payload)
      .then(async res => {
        this.navStore.resetBackbarStack();
        await this.handleDepositResponse(res);
      })
      .catch(err => {
        // console.log("Deposit funds square error", err);
        let errorMsg =
          "There was a problem encountered while making the deposit";
        if (
          err &&
          err.message &&
          err !== undefined &&
          err.message !== undefined
        ) {
          errorMsg = `${errorMsg}: ${err.message}`;
        }
        this.successMessage = null;
        this.errorMessage = errorMsg;
        this.isProcessing = false;
        if (
          this.errorMessage !== undefined &&
          this.errorMessage.indexOf("Invalid cardNonce") > -1
        ) {
          this.errorMessage =
            this.errorMessage +
            ". Please try removing your card via Your Account | Payment Methods on the left hand menu. After removing, re-enter the card information. If the problem continues, contact support@funfangle.com";
        }
        WebappLogger.warn(errorMsg, 'MakeDeposit.depositFundsSquare.catch', err.name, undefined, this.profileStore.organizationId, this.profileStore.userId).catch();
      });
    // complete payment
    // this.goNotImplemented()
    /*
    // add hash to URL
    window.location.hash = 'confirm'
    // change the section viewed
    this.activeSection = 'confirm'
    */
  }
  openAddAuthorizedUser(): void {
    this.goAuthorizedUserAddPage();
  }
  rowStyle(index: number) {
    if (index % 2 === 0) {
      return "background: #f0f0f0";
    }
    return "";
  }
  setup() {
    // TODO: This code is in three different places. COnsolidate to a common library
    this.cardString = null;
    // console.log('processorSettings: ', this.getOrganization().processorSettings);
    if (
      this.profileStore.currOrganization !== undefined &&
      this.profileStore.currOrganization.processorSettings !== undefined &&
      this.profileStore.currOrganization.processorSettings.webProcessor !== undefined
    ) {
      this.webProcessor = this.profileStore.currOrganization.processorSettings.webProcessor;
    } else {
      this.errorMessage = "Web Processor Not Configured";
      WebappLogger.error(this.errorMessage, 'MakeDeposit.setup', 'NO_WEB_PROCESSOR', undefined, this.profileStore.organizationId, this.profileStore.userId).catch();
    }
    // this.webProcessor = 'square';
    // if the processor is square
    // determine if payment method is set
    if (this.webProcessor === "square") {
      if (this.paymentMethods.length > 0) {
        this.processorSquareDefaultCard = this.paymentMethods.find((card: PaymentMethod) => card.isDefault || card.cardId === this.profileStore.squareInfo?.defaultCardId);
        if (this.processorSquareDefaultCard && this.processorSquareDefaultCard !== undefined) {
          this.hasCard = true;
          this.cardString = `${this.processorSquareDefaultCard.brand || ''} *${this.processorSquareDefaultCard.last4}`;
          // } else {
          //   this.cardString = this.$tc("phrase.card_default_not_set");
          //   this.activeSection = "#add-card";
          // TODO handle this better
        }
        // } else {
        //   this.cardString = this.$tc("phrase.card_not_on_file");
        //   this.activeSection = "#add-card";
      }
    }
    // default to form
    if (window.location.hash === "") {
      this.activeSection = "#deposits-form";
    }
    // ...
    this.participants = this.profileStore.authorizedActiveUsers
      .concat(this.bankStore.contributingToActive)
      .map(person => {
        const u = person as EditableUser;
        u.deposit = null;
        return u;
      });
    this.refundDonateOptions = [];
    if (this.profileStore !== undefined && this.profileStore.currOrganization !== undefined && this.profileStore.currOrganization.donateOptions !== undefined) {
      this.profileStore.currOrganization.donateOptions.forEach(option => {
        let opt = {
          value: {
            refundDonate: "donate",
            donateSelection: option
          },
          text: `Donate remaining to ${option}`
        };
        this.refundDonateOptions.push(opt);
      });
    }
    if (this.displayDonateOptions === true && this.refundDonateOptions.length === 0) {
      const option = 'where needed most';
      let opt = {
        value: {
          refundDonate: "donate",
          donateSelection: option
        },
        text: `Donate remaining to ${option}`
      };
      this.refundDonateOptions.push(opt);
    }
    // build option for refund
    // TODO: Is this right? Should it be on the user object, not the organization object?
    this.refundThreshold = Number(this.profileStore.currUser.refundThreshold) || 0;
    let textVal =
      "Refund remaining funds" +
      (this.refundThreshold > 0 ? ` above ${this.refundThreshold}` : "");
    this.refundDonateOptions.push({
      value: {
        refundDonate: "refund"
      },
      text: textVal
    });
  }

  created() {}
  mounted() {
    if (window.location.hash !== "deposits-form") {
      this.activeSection = "#deposits-form";
      window.location.hash = "deposits-form";
    }
    this.setup();
  }
}
